import { callApi } from '@/helpers/api';
import CONFIG from '@/config/global';

const { api: { HOST, GET_CHANNELS_BY_SEED } } = CONFIG;

// Get channels by seed id. This is used to get similar or related channels
const getChannelsBySeed = (id) => {
  return callApi({
    url: HOST(GET_CHANNELS_BY_SEED) + GET_CHANNELS_BY_SEED.replace(':seed', id),
    queryParams: { l: 15 }
  });
};

export default getChannelsBySeed;